import { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";

export const useAuthentication = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuthentication must be used within an AuthProvider");
  }

  return context;
};
